// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"15de3aa3","274":"8ca5e8a0","615":"6852f655","890":"b73ce9cc"}[chunkId] + ".chunk.js";
};